var _metadata, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4R(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 16 16",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(39,39,39,0.9686274509803922)",
    d: "M1 1h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020202",
    d: "M1 2h2M3 3h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M2 3h1M3 4h2M3 5h3M4 6h3M3 7h3M1 8h4M2 9h3M3 10h3M4 11h3M3 12h2M6 12h1M2 13h1M2 14h1M3 15h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.0784313725490196)",
    d: "M5 8h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.00392156862745098)",
    d: "M5 12h1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#272727",
    d: "M3 13h1M3 14h1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4R);
export default __webpack_public_path__ + "static/media/4r.617d26742e65cb4113842f7810ea7c37.svg";
export { ForwardRef as ReactComponent };